import { capitalize } from "lodash";
import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Button } from "@livechat/design-system-react-components";

import { IconsEnum } from "components/icon";
import Text from "components/layout/Text";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { ITicket, TicketSilo } from "interfaces/entities/ticket";
import { AgentsRoutes } from "routes/agents/constants";
import { selectIsViewer } from "store/entities/agents";

import { StyledAccessWarning, StyledAccessWarningIcon } from "./styles";

interface IProps {
  ticket: ITicket;
  disabled: boolean;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSiloChange: (silo: any) => void;
}

export const TicketSiloLabel: React.FC<IProps> = ({ ticket, disabled, handleSiloChange }) => {
  const { silo } = ticket;
  const isViewer = useSelector(selectIsViewer);
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const moveTicketToRecent = () => {
    handleSiloChange(TicketSilo.Tickets);
    trackEngagement("Tickets: Change silo actions", EventPlace.TicketTopLink, {
      from: silo,
      to: TicketSilo.Tickets,
      place: EventPlace.TicketTopLink,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleContactAdmin = () => {
    history.push(AgentsRoutes.Agents);
  };

  if (silo === TicketSilo.Tickets) {
    return null;
  }

  return (
    <StyledAccessWarning>
      <StyledAccessWarningIcon name={IconsEnum.Info} width="15px" height="15px" inline />
      {silo === TicketSilo.Spam &&
        (isViewer ? (
          <>
            This ticket is in Spam. To edit the ticket,&nbsp;
            <Button kind="link" onClick={handleContactAdmin}>
              <Text inline fontSize="13px">
                contact any admin
              </Text>
            </Button>
            &nbsp; to change your role.
          </>
        ) : (
          <>
            This ticket is in {capitalize(ticket.silo)}. To edit the ticket, mark it as&nbsp;
            <Button kind="link" disabled={disabled} onClick={moveTicketToRecent}>
              <Text inline fontSize="13px">
                not spam
              </Text>
            </Button>
            .
          </>
        ))}
      {silo === TicketSilo.Trash &&
        (isViewer ? (
          <>
            This ticket is in Trash. To edit the ticket,&nbsp;
            <Button kind="link" onClick={handleContactAdmin}>
              <Text inline fontSize="13px">
                contact any admin
              </Text>
            </Button>
            &nbsp; to change your role.
          </>
        ) : (
          <>
            This ticket is in {capitalize(ticket.silo)}. To edit the ticket,&nbsp;
            <Button kind="link" disabled={disabled} onClick={moveTicketToRecent}>
              <Text inline fontSize="13px">
                restore it
              </Text>
            </Button>
            .
          </>
        ))}
      {silo === TicketSilo.Archive &&
        (isViewer ? (
          <>
            This ticket is in the Archive. To edit the ticket,&nbsp;
            <Button kind="link" onClick={handleContactAdmin}>
              <Text inline fontSize="13px">
                contact any admin
              </Text>
            </Button>
            &nbsp; to change your role.
          </>
        ) : (
          <>
            This ticket is in {capitalize(ticket.silo)}. To edit the ticket,&nbsp;
            <Button kind="link" disabled={disabled} onClick={moveTicketToRecent}>
              <Text inline fontSize="13px">
                unarchive it
              </Text>
            </Button>
            .
          </>
        ))}
    </StyledAccessWarning>
  );
};
